"use client";
import { useContext } from "react";
import { StadiumSharedGlobalConfigContext } from "@stadium/shared/src/contexts/global-config";

const useStadiumSharedGlobalConfigContext = () => useContext(StadiumSharedGlobalConfigContext);

export default useStadiumSharedGlobalConfigContext;
